import { render, staticRenderFns } from "./CMSBlogTagShow.vue?vue&type=template&id=60a0d60b&"
import script from "./CMSBlogTagShow.vue?vue&type=script&lang=js&"
export * from "./CMSBlogTagShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports